<template>
    <TableLayout :permissions="['business:member:query']">
        <!-- 搜索表单 -->
        <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="100px" inline>
            <el-form-item label="姓名" prop="name">
                <el-input v-model="searchForm.name" placeholder="请输入姓名" @keypress.enter.native="search"></el-input>
            </el-form-item>
            <el-form-item label="工号" prop="code">
                <el-input v-model="searchForm.code" placeholder="请输入工号" @keypress.enter.native="search"></el-input>
            </el-form-item>
            <el-form-item label="部门" prop="companyId">
                <el-cascader
                    :options="options"
                    v-model="searchForm.companyId"
                    @change="changeCompanyId"
                    :show-all-levels="false"
                    @keypress.enter.native="search"
                    :props="{ checkStrictly: true, value: 'id', label: 'name', children: 'companyDTOList' }"
                    ></el-cascader>
            </el-form-item>
            <section>
                <el-button type="primary" @click="search">搜索</el-button>
                <el-button @click="reset">重置</el-button>
            </section>
        </el-form>
        <!-- 表格和分页 -->
        <template v-slot:table-wrap>
            <ul class="toolbar" v-permissions="['business:member:create', 'business:member:delete']">
                <li><el-button type="primary" v-permissions="['business:member:create']" @click="thaws()">解冻</el-button></li>
                <li><el-button type="primary" :loading="isWorking.export" v-permissions="['business:member:exportExcel']" @click="exportExcel">导出</el-button></li>
            </ul>
            <el-table
                v-loading="isWorking.search"
                :data="tableData.list"
                stripe
                @selection-change="handleSelectionChange"
            >
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column prop="name" label="姓名" min-width="100px"></el-table-column>
                <el-table-column prop="companyName" label="部门" min-width="100px"></el-table-column>
                <el-table-column prop="code" label="工号" min-width="100px"></el-table-column>
                <el-table-column prop="visitsLastDate" label="最后一次门禁时间" min-width="100px"></el-table-column>
                <el-table-column prop="userActionType1" label="冻结时间" min-width="100px"></el-table-column>
                <el-table-column
                    v-if="containPermissions(['business:member:update', 'business:member:delete'])"
                    label="操作"
                    min-width="120"
                    fixed="right"
                >
                    <template slot-scope="{row}">
                        <el-button type="text" @click="thaw([{id: row.id}])" icon="el-icon-edit" v-permissions="['business:member:update']">解冻</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <pagination
                @size-change="handleSizeChange"
                @current-change="handlePageChange"
                :pagination="tableData.pagination"
            >
            </pagination>
        </template>
    </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
import { findCompanyTreePage } from '@/api/business/company'
import { updateRemoveStatusById } from '@/api/business/block'
export default {
  name: 'freezePersonnel',
  extends: BaseTable,
  components: { TableLayout, Pagination },
  data () {
    return {
      // 搜索
      searchForm: {
        companyId: '',
        name: '',
        code: '',
        type: 2
      },
      options: []
    }
  },
  created () {
    this.config({
      module: '冻结人员',
      api: '/business/block',
      'field.id': 'id',
      'field.main': 'id'
    })
    this.search()
    this.getfindCompanyTreePage()
  },
  methods: {
    thaws () {
      if (this.tableData.selectedRows.length === 0) return this.$message.warning('至少选择一项内容')
      const ids = this.tableData.selectedRows.map(item => {
        return { id: item.id }
      })
      this.thaw(ids)
    },
    thaw (ids) {
      this.$confirm('确定解冻此用户吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        updateRemoveStatusById(ids)
          .then(res => {
            this.$message.success('操作成功')
            this.search()
          })
      }).catch(() => {

      })
    },
    changeCompanyId (e) {
      this.searchForm.companyId = e[e.length - 1]
    },
    // 获取组织树
    getfindCompanyTreePage () {
      findCompanyTreePage(1)
        .then(res => {
          this.options = res
        })
    }
  }
}
</script>
